import { applyBrandPalette, applyBrandSections } from './brand';
import { addContactNavigation } from './contactNavigation';

const assets = {
  'https://theinstaserv.com/wp-content/uploads/2026/09/jos-logo-white.webp': '/brand/jos-approved-reversed-trimmed.png',
  'https://theinstaserv.com/wp-content/uploads/2026/09/image-47.webp': '/images/consultation-family.webp',
  'https://theinstaserv.com/wp-content/uploads/2026/09/image-56.webp': '/images/consultation-background.webp',
  'https://media.base44.com/images/public/6aacf5733908f8d410b63fa8/8a5d5a54c_generated_63aeea30.jpg': '/images/contact-office.jpg',
};

const names = {
  'jil-id-root-1': 'landing-content',
  'jil-sec-home-186': 'hero-section',
  'jil-sec-consultation-194': 'consultation-section',
  'jil-sec-practice-areas-196': 'practice-areas-section',
  'jil-sec-team-193': 'team-section',
  'jil-sec-process-197': 'process-section',
  'jil-sec-testimonials-198': 'testimonials-section',
  'jil-sec-contact-192': 'contact-section',
  'jil-id-form-one-195': 'consultation-form',
  'jil-id-form-two-206': 'contact-form',
  'jil-id-lang-btn-188': 'language-menu-button',
  'jil-id-lang-label-189': 'selected-language',
  'jil-id-lang-menu-190': 'language-menu',
  'jil-id-slide-text-200': 'testimonial-text',
  'jil-id-slide-name-201': 'testimonial-name',
  'jil-id-slide-role-202': 'testimonial-role',
  'jil-id-next-205': 'next-testimonial-button',
  'jil-id-prev-203': 'previous-testimonial-button',
  'jos-header-contact-actions': 'header-contact-actions',
  'jos-header-phone-link': 'header-phone-link',
  'jos-final-contact-form': 'final-contact-form-panel',
};

const slug = text => text.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');

/** The archived public reference is inert: only the scoped landing content is used.
 * No WordPress scripts, trackers, stylesheets, or inline event handlers are executed.
 */
export function prepareReference(source) {
  const document = new DOMParser().parseFromString(source, 'text/html');
  const root = document.querySelector('#jil-id-root-1');
  const stylesheet = [...document.querySelectorAll('style')].find(style => style.textContent.includes('SCOPED BASE'));
  if (!root || !stylesheet) throw new Error('Reference content missing');
  // The supplied reference remains archived, but removed team members must never
  // render in the current page (including their photo, role and image alt text).
  root.querySelectorAll('#jil-sec-team-193 .jil-tm-card-178').forEach(card => {
    const name = card.querySelector('.jil-tm-name-182')?.textContent.trim().toLowerCase();
    if (name === 'kristen miyamoto') card.remove();
  });
  let css = applyBrandPalette(stylesheet.textContent);
  applyBrandSections(root);
  root.querySelectorAll('script, style, iframe, object, embed').forEach(el => el.remove());
  root.querySelector('#jil-id-gt-191')?.remove();
  addContactNavigation(root);
  // Our submit handler shows persistent, accessible errors instead of relying on
  // mobile-native validation tooltips that can disappear behind a sticky footer.
  root.querySelectorAll('.jil-lead-form-104').forEach(form => {
    form.noValidate = true;
    // If scripts have not bound yet, never fall back to a GET containing lead PII.
    form.method = 'post';
    form.action = `${process.env.REACT_APP_BACKEND_URL}/api/leads`;
    form.querySelector('button[type="submit"]').disabled = true;
  });
  // Keep canonical option values even when Google Translate changes the labels.
  root.querySelectorAll('select option').forEach(option => {
    if (!option.hasAttribute('value')) option.setAttribute('value', option.textContent.trim());
  });
  root.querySelectorAll('input[name="first_name"], input[name="last_name"]').forEach(input => input.maxLength = 80);
  root.querySelectorAll('input[name="phone"]').forEach(input => { input.maxLength = 32; input.pattern = '\\+?[0-9\\s\\(\\).\\-]{7,32}'; });
  root.querySelectorAll('input[name="email"]').forEach(input => input.maxLength = 254);
  root.querySelectorAll('textarea[name="message"]').forEach(input => input.maxLength = 5000);
  const counts = {};
  [root, ...root.querySelectorAll('*')].forEach(el => {
    [...el.attributes].forEach(attr => { if (/^on/i.test(attr.name)) el.removeAttribute(attr.name); });
    if (assets[el.getAttribute('src')]) el.setAttribute('src', assets[el.getAttribute('src')]);
    if (el.tagName === 'A' && el.target === '_blank') el.rel = 'noopener noreferrer';
    const form = el.closest('form');
    let base = names[el.id];
    if (!base && el.dataset.lang) base = `language-${el.dataset.lang}-option`;
    if (!base && form && el.name) base = `${names[form.id]}-${slug(el.name)}`;
    if (!base && el.matches('button[type="submit"]')) base = `${names[form.id]}-submit-button`;
    if (!base) base = slug(el.getAttribute('aria-label') || el.getAttribute('alt') || el.classList[0] || el.tagName);
    counts[base] = (counts[base] || 0) + 1;
    el.dataset.testid = counts[base] === 1 ? base : `${base}-${counts[base]}`;
  });
  Object.entries(assets).forEach(([remote, local]) => { css = css.split(remote).join(local); });
  root.querySelectorAll('.jil-ct-thanks-113').forEach(el => { el.setAttribute('role', 'status'); el.setAttribute('aria-live', 'polite'); });
  root.querySelector('#jil-id-slide-199').setAttribute('aria-live', 'polite');
  return { html: root.outerHTML, css };
}